import { FC } from "react";

/**
 * Warning Icon Props Interface
 * @interface WarningProps
 */

interface WarningProps {
  /** display width of the icon */
  width?: string;
  /** display height of the icon */
  height?: string;
  /** apply the color of the icon */
  color?: string;
}

const Warning: FC<WarningProps> = ({ width, height, color }) => {
  return (
    <svg
      className={`min-w-${width ? width : "24"}px`}
      width={width ? width : "24"}
      height={height ? height : "24"}
      // style={{ marginBottom: "2px" }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={color ? color : "black"}
      ></path>
    </svg>
  );
};

export default Warning;
